<ng-container *ngFor="let audit of translatedLinks; let i = index">
    <a (click)="onClick(fieldsWithLinks[i])">Check {{audit}} Section</a> {{i+1 < translatedLinks.length ? "," : ""}}
</ng-container>
{{nonLinks.length > 0 ? "," : ""}}
{{nonLinks}} 
